var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#6D7781",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33464 15.3333H7.1613C7.01586 15.2942 6.88793 15.2071 6.79835 15.086C6.70877 14.965 6.66281 14.8171 6.66797 14.6666V8.66663H3.33464C3.15782 8.66663 2.98826 8.59639 2.86323 8.47136C2.73821 8.34634 2.66797 8.17677 2.66797 7.99996V1.33329C2.66797 1.15648 2.73821 0.986912 2.86323 0.861888C2.98826 0.736864 3.15782 0.666626 3.33464 0.666626H7.33464C7.51145 0.666626 7.68102 0.736864 7.80604 0.861888C7.93106 0.986912 8.0013 1.15648 8.0013 1.33329V4.66663H12.668C12.7854 4.66616 12.901 4.69674 13.0028 4.75528C13.1047 4.81381 13.1892 4.89822 13.248 4.99996C13.3065 5.1013 13.3373 5.21627 13.3373 5.33329C13.3373 5.45032 13.3065 5.56528 13.248 5.66663L7.91464 15C7.8559 15.1017 7.77132 15.1861 7.66947 15.2446C7.56762 15.3032 7.45211 15.3338 7.33464 15.3333ZM4.0013 7.33329H7.33464C7.51145 7.33329 7.68102 7.40353 7.80604 7.52855C7.93106 7.65358 8.0013 7.82315 8.0013 7.99996V12.1533L11.5213 5.99996H7.33464C7.15782 5.99996 6.98825 5.92972 6.86323 5.8047C6.73821 5.67967 6.66797 5.5101 6.66797 5.33329V1.99996H4.0013V7.33329Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H16V16.5H0V0.5Z",
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.af0cae9f.svg";
export { ForwardRef as ReactComponent };